// core
import { Component, Inject, OnInit } from '@angular/core';
import { matDialog } from '@campfire-nx/material';

@Component({
  selector: 'open-raptor-default-interstitial.component',
  templateUrl: './default-interstitial.component.html',
  styleUrls: ['./default-interstitial.component.scss']
})
export class DefaultInterstitialComponent implements OnInit {
  styles: any[] = [];

  constructor(@Inject(matDialog.MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.styles = [];

    if (this.data && this.data.content && this.data.content.length) {
      const duration = (this.data.time / this.data.content.length) - 5;
      let delay = 0;

      for (let index = 0; index < this.data.content.length; index++) {
        const style = {
          animationDuration: `${duration}ms`,
          animationDelay: `${delay}ms`,
        }
        this.styles.push(style);
        delay += duration;
      }
    }
  }
}
